import MobileNav from './MobileNav';

const mobileNav = new MobileNav();
mobileNav.init();
